<template>
<section class="link-grid p-4">
    <div class="max-w-4xl mx-auto">
        <SmoothLoader v-if="headline" tag="h2" class="font-headline text-3xl vt:text-4rem text-center font-bold mb-4 text-primary-700 leading-tight" v-html="headline"></SmoothLoader>
        <SmoothLoader class="blurb max-w-xl mx-auto prose mt-4 mb-8 text-center text-gray-800" v-html="blurb" v-if="blurb">
        </SmoothLoader>
        <SmoothLoader class="grid" :class="`columns-${cols}`">
            <div v-for="link in links" class="cell">
                <Link :href="link.href" class="block px-4 pt-4 vt:px-8 vt:pt-8 pb-16 rounded-lg bg-gray-300 relative h-full">
                    <span v-if="link.kicker" class="kicker block font-headline uppercase font-bold text-primary-400" v-html="link.kicker"></span>
                    <span v-if="link.headline" class="headline block font-headline text-lg font-bold text-primary-700" v-html="link.headline"></span>
                    <div v-if="link.blurb" class="blurb prose text-gray-800 font-body mt-6" v-html="link.blurb"></div>
                    <div class="corner absolute" aria-hidden="true">
                        <i class="fa-solid fa-circle-plus text-xl"></i>
                    </div>
                </Link>
            </div>
        </SmoothLoader>
    </div>
</section>
</template>

<script>
import { computed } from 'vue';

export default {

    props: ['data'],
    
    setup(props) {
        const cols = computed(() => {
            return Math.min(props.data.links.length, 3);
        });
        return {
            ...props.data,
            cols
        }
    }

}
</script>